// GENERATED FILE, PLEASE DO NOT EDIT
export var BackgroundPrimary = '#ffffff';
export var BackgroundPrimaryInverted = '#1F2327';
export var BackgroundSecondary = '#FAFAFA';
export var BackgroundSecondaryInverted = '#2D3C48';
export var BackgroundTertiary = '#EFF1F3';
export var BackgroundElevated = '#ffffff';
export var BackgroundOverlay = '#2D3C48';
export var BannerDefaultBackground = '#FAFAFA';
export var BannerDefaultForeground = '#2D3C48';
export var BannerDefaultIcon = '#2D3C48';
export var BannerHighlightBackground = '#DEF1FA';
export var BannerHighlightForeground = '#2D3C48';
export var BannerHighlightIcon = '#009AD4';
export var BannerInformationalBackground = '#2D3C48';
export var BannerInformationalForeground = '#ffffff';
export var BannerInformationalIcon = '#ffffff';
export var BannerNegativeBackground = '#FFCCCC';
export var BannerNegativeForeground = '#2D3C48';
export var BannerNegativeIcon = '#D92B2B';
export var BannerPositiveBackground = '#DFEFD9';
export var BannerPositiveForeground = '#2D3C48';
export var BannerPositiveIcon = '#24B324';
export var BannerWarningBackground = '#FFF0C2';
export var BannerWarningForeground = '#2D3C48';
export var BannerWarningIcon = '#E5B82E';
export var BorderPrimary = '#EFF1F3';
export var BorderSecondary = '#CCD1D5';
export var ButtonDefaultToggleForegroundDisabled = '#6E767E';
export var ButtonDefaultToggleForegroundOff = '#2D3C48';
export var ButtonDefaultToggleForegroundOffDisabled = '#6E767E';
export var ButtonDefaultToggleForegroundOffHovered = '#2D3C48';
export var ButtonDefaultToggleForegroundOffPressed = '#2D3C48';
export var ButtonFabBackground = '#FAFAFA';
export var ButtonFabBackgroundHovered = '#EFF1F3';
export var ButtonFabBackgroundPressed = '#CCD1D5';
export var ButtonFabForeground = '#1F2327';
export var ButtonFabForegroundHovered = '#1F2327';
export var ButtonFabForegroundPressed = '#1F2327';
export var ButtonFlatPrimaryForeground = '#F86932';
export var ButtonFlatPrimaryForegroundDisabled = '#6E767E';
export var ButtonFlatPrimaryForegroundHovered = '#DF5F2D';
export var ButtonFlatPrimaryForegroundPressed = '#C65428';
export var ButtonFlatSecondaryForeground = '#2D3C48';
export var ButtonFlatSecondaryForegroundDisabled = '#6E767E';
export var ButtonFlatSecondaryForegroundHovered = '#26333D';
export var ButtonFlatSecondaryForegroundPressed = '#1F2327';
export var ButtonPlainForeground = '#2D3C48';
export var ButtonPlainForegroundDisabled = '#6E767E';
export var ButtonPlainForegroundHovered = '#2D3C48';
export var ButtonPlainForegroundPressed = '#2D3C48';
export var ButtonPlainToggleForeground = '#2D3C48';
export var ButtonPlainToggleForegroundDisabled = '#6E767E';
export var ButtonPlainToggleForegroundHovered = '#2D3C48';
export var ButtonPlainToggleForegroundOff = '#2D3C48';
export var ButtonPlainToggleForegroundOffDisabled = '#6E767E';
export var ButtonPlainToggleForegroundOffHovered = '#2D3C48';
export var ButtonPlainToggleForegroundOffPressed = '#2D3C48';
export var ButtonPlainToggleForegroundPressed = '#2D3C48';
export var ButtonPrimaryBackground = '#F86932';
export var ButtonPrimaryBackgroundDisabled = '#FAFAFA';
export var ButtonPrimaryBackgroundHovered = '#DF5F2D';
export var ButtonPrimaryBackgroundPressed = '#C65428';
export var ButtonPrimaryForeground = '#ffffff';
export var ButtonPrimaryForegroundDisabled = '#6E767E';
export var ButtonPrimaryForegroundHovered = '#ffffff';
export var ButtonPrimaryForegroundPressed = '#ffffff';
export var ButtonPrimaryToggleBackground = '#2D3C48';
export var ButtonPrimaryToggleBackgroundDisabled = '#CCD1D5';
export var ButtonPrimaryToggleBackgroundHovered = '#4B5862';
export var ButtonPrimaryToggleBackgroundPressed = '#26333D';
export var ButtonPrimaryToggleBackgroundOff = '#EFF1F3';
export var ButtonPrimaryToggleBackgroundOffDisabled = '#FAFAFA';
export var ButtonPrimaryToggleBackgroundOffHovered = '#FAFAFA';
export var ButtonPrimaryToggleBackgroundOffPressed = '#CCD1D5';
export var ButtonPrimaryToggleBorderOff = '#EFF1F3';
export var ButtonPrimaryToggleBorderOffHovered = '#FAFAFA';
export var ButtonPrimaryToggleBorderOffPressed = '#CCD1D5';
export var ButtonPrimaryToggleBorderOffDisabled = '#FAFAFA';
export var ButtonPrimaryToggleBorderOn = '#2D3C48';
export var ButtonPrimaryToggleBorderOnHovered = '#4B5862';
export var ButtonPrimaryToggleBorderOnPressed = '#26333D';
export var ButtonPrimaryToggleBorderOnDisabled = '#CCD1D5';
export var ButtonPrimaryToggleForeground = '#ffffff';
export var ButtonPrimaryToggleForegroundDisabled = '#6E767E';
export var ButtonPrimaryToggleForegroundHovered = '#ffffff';
export var ButtonPrimaryToggleForegroundPressed = '#ffffff';
export var ButtonPrimaryToggleForegroundOff = '#2D3C48';
export var ButtonPrimaryToggleForegroundOffDisabled = '#6E767E';
export var ButtonPrimaryToggleForegroundOffHovered = '#2D3C48';
export var ButtonPrimaryToggleForegroundOffPressed = '#2D3C48';
export var ButtonSecondaryBackground = '#2D3C48';
export var ButtonSecondaryBackgroundDisabled = '#FAFAFA';
export var ButtonSecondaryBackgroundHovered = '#26333D';
export var ButtonSecondaryBackgroundPressed = '#1F2327';
export var ButtonSecondaryForeground = '#ffffff';
export var ButtonSecondaryForegroundDisabled = '#6E767E';
export var ButtonSecondaryForegroundHovered = '#ffffff';
export var ButtonSecondaryForegroundPressed = '#ffffff';
export var ButtonSecondaryToggleBackground = '#2D3C48';
export var ButtonSecondaryToggleBackgroundDisabled = '#6E767E';
export var ButtonSecondaryToggleBackgroundHovered = '#4B5862';
export var ButtonSecondaryToggleBackgroundPressed = '#26333D';
export var ButtonSecondaryToggleBackgroundOff = '#EFF1F3';
export var ButtonSecondaryToggleBackgroundOffDisabled = '#FAFAFA';
export var ButtonSecondaryToggleBackgroundOffHovered = '#FAFAFA';
export var ButtonSecondaryToggleBackgroundOffPressed = '#CCD1D5';
export var ButtonSecondaryToggleBorderOff = '#EFF1F3';
export var ButtonSecondaryToggleBorderOffHovered = '#FAFAFA';
export var ButtonSecondaryToggleBorderOffPressed = '#CCD1D5';
export var ButtonSecondaryToggleBorderOffDisabled = '#FAFAFA';
export var ButtonSecondaryToggleBorderOn = '#2D3C48';
export var ButtonSecondaryToggleBorderOnHovered = '#4B5862';
export var ButtonSecondaryToggleBorderOnPressed = '#26333D';
export var ButtonSecondaryToggleBorderOnDisabled = '#CCD1D5';
export var ButtonSecondaryToggleForeground = '#ffffff';
export var ButtonSecondaryToggleForegroundDisabled = '#6E767E';
export var ButtonSecondaryToggleForegroundHovered = '#ffffff';
export var ButtonSecondaryToggleForegroundPressed = '#ffffff';
export var ButtonSecondaryToggleForegroundOff = '#2D3C48';
export var ButtonSecondaryToggleForegroundOffDisabled = '#6E767E';
export var ButtonSecondaryToggleForegroundOffHovered = '#2D3C48';
export var ButtonSecondaryToggleForegroundOffPressed = '#2D3C48';
export var ButtonTertiaryBackground = '#EFF1F3';
export var ButtonTertiaryBackgroundDisabled = '#FAFAFA';
export var ButtonTertiaryBackgroundHovered = '#CCD1D5';
export var ButtonTertiaryBackgroundPressed = '#6E767E';
export var ButtonTertiaryBorder = '#EFF1F3';
export var ButtonTertiaryBorderDisabled = '#FAFAFA';
export var ButtonTertiaryBorderHovered = '#CCD1D5';
export var ButtonTertiaryBorderPressed = '#6E767E';
export var ButtonTertiaryForeground = '#2D3C48';
export var ButtonTertiaryForegroundDisabled = '#6E767E';
export var ButtonTertiaryForegroundHovered = '#2D3C48';
export var ButtonTertiaryForegroundPressed = '#2D3C48';
export var ButtonTertiaryToggleBackground = '#2D3C48';
export var ButtonTertiaryToggleBackgroundDisabled = '#CCD1D5';
export var ButtonTertiaryToggleBackgroundHovered = '#2D3C48';
export var ButtonTertiaryToggleBackgroundPressed = '#26333D';
export var ButtonTertiaryToggleBackgroundOff = '#EFF1F3';
export var ButtonTertiaryToggleBackgroundOffDisabled = '#FAFAFA';
export var ButtonTertiaryToggleBackgroundOffHovered = '#EFF1F3';
export var ButtonTertiaryToggleBackgroundOffPressed = '#CCD1D5';
export var ButtonTertiaryToggleBorderOff = '#EFF1F3';
export var ButtonTertiaryToggleBorderOffHovered = '#EFF1F3';
export var ButtonTertiaryToggleBorderOffPressed = '#CCD1D5';
export var ButtonTertiaryToggleBorderOffDisabled = '#FAFAFA';
export var ButtonTertiaryToggleBorderOn = '#2D3C48';
export var ButtonTertiaryToggleBorderOnHovered = '#2D3C48';
export var ButtonTertiaryToggleBorderOnPressed = '#26333D';
export var ButtonTertiaryToggleBorderOnDisabled = '#CCD1D5';
export var ButtonTertiaryToggleForeground = '#ffffff';
export var ButtonTertiaryToggleForegroundDisabled = '#6E767E';
export var ButtonTertiaryToggleForegroundHovered = '#CCD1D5';
export var ButtonTertiaryToggleForegroundPressed = '#ffffff';
export var ButtonTertiaryToggleForegroundOff = '#2D3C48';
export var ButtonTertiaryToggleForegroundOffDisabled = '#CCD1D5';
export var ButtonTertiaryToggleForegroundOffHovered = '#1F2327';
export var ButtonTertiaryToggleForegroundOffPressed = '#1F2327';
export var ButtonPrimaryToggleGroupBackgroundOff = '#EFF1F3';
export var ButtonPrimaryToggleGroupBackgroundOffHovered = '#EFF1F3';
export var ButtonPrimaryToggleGroupBackgroundOffPressed = '#CCD1D5';
export var ButtonPrimaryToggleGroupBackgroundOffDisabled = '#FAFAFA';
export var ButtonPrimaryToggleGroupBorderOff = '#EFF1F3';
export var ButtonPrimaryToggleGroupBorderOffHovered = '#EFF1F3';
export var ButtonPrimaryToggleGroupBorderOffPressed = '#CCD1D5';
export var ButtonPrimaryToggleGroupBorderOffDisabled = '#FAFAFA';
export var ButtonPrimaryToggleGroupForegroundOff = '#2D3C48';
export var ButtonPrimaryToggleGroupForegroundOffHovered = '#1F2327';
export var ButtonPrimaryToggleGroupForegroundOffPressed = '#1F2327';
export var ButtonPrimaryToggleGroupForegroundOffDisabled = '#CCD1D5';
export var ButtonPrimaryToggleGroupBackgroundOn = '#2D3C48';
export var ButtonPrimaryToggleGroupBackgroundOnHovered = '#2D3C48';
export var ButtonPrimaryToggleGroupBackgroundOnPressed = '#26333D';
export var ButtonPrimaryToggleGroupBackgroundOnDisabled = '#CCD1D5';
export var ButtonPrimaryToggleGroupBorderOn = '#101216';
export var ButtonPrimaryToggleGroupBorderOnHovered = '#26333D';
export var ButtonPrimaryToggleGroupBorderOnPressed = '#1F2327';
export var ButtonPrimaryToggleGroupBorderOnDisabled = '#FAFAFA';
export var ButtonPrimaryToggleGroupForegroundOnDisabled = '#6E767E';
export var ButtonSecondaryToggleGroupBackgroundOff = '#EFF1F3';
export var ButtonSecondaryToggleGroupBackgroundOffHovered = '#EFF1F3';
export var ButtonSecondaryToggleGroupBackgroundOffPressed = '#CCD1D5';
export var ButtonSecondaryToggleGroupBackgroundOffDisabled = '#FAFAFA';
export var ButtonSecondaryToggleGroupBorderOff = '#EFF1F3';
export var ButtonSecondaryToggleGroupBorderOffHovered = '#EFF1F3';
export var ButtonSecondaryToggleGroupBorderOffPressed = '#CCD1D5';
export var ButtonSecondaryToggleGroupBorderOffDisabled = '#FAFAFA';
export var ButtonSecondaryToggleGroupForegroundOff = '#2D3C48';
export var ButtonSecondaryToggleGroupForegroundOffHovered = '#1F2327';
export var ButtonSecondaryToggleGroupForegroundOffPressed = '#1F2327';
export var ButtonSecondaryToggleGroupForegroundOffDisabled = '#CCD1D5';
export var ButtonSecondaryToggleGroupBackgroundOn = '#2D3C48';
export var ButtonSecondaryToggleGroupBackgroundOnHovered = '#2D3C48';
export var ButtonSecondaryToggleGroupBackgroundOnPressed = '#26333D';
export var ButtonSecondaryToggleGroupBackgroundOnDisabled = '#CCD1D5';
export var ButtonSecondaryToggleGroupBorderOn = '#101216';
export var ButtonSecondaryToggleGroupBorderOnHovered = '#26333D';
export var ButtonSecondaryToggleGroupBorderOnPressed = '#1F2327';
export var ButtonSecondaryToggleGroupBorderOnDisabled = '#FAFAFA';
export var ButtonSecondaryToggleGroupForegroundOnDisabled = '#6E767E';
export var ButtonTertiaryToggleGroupBackgroundOff = '#EFF1F3';
export var ButtonTertiaryToggleGroupBackgroundOffHovered = '#EFF1F3';
export var ButtonTertiaryToggleGroupBackgroundOffPressed = '#CCD1D5';
export var ButtonTertiaryToggleGroupBackgroundOffDisabled = '#FAFAFA';
export var ButtonTertiaryToggleGroupBorderOff = '#EFF1F3';
export var ButtonTertiaryToggleGroupBorderOffHovered = '#EFF1F3';
export var ButtonTertiaryToggleGroupBorderOffPressed = '#CCD1D5';
export var ButtonTertiaryToggleGroupBorderOffDisabled = '#FAFAFA';
export var ButtonTertiaryToggleGroupForegroundOff = '#2D3C48';
export var ButtonTertiaryToggleGroupForegroundOffHovered = '#1F2327';
export var ButtonTertiaryToggleGroupForegroundOffPressed = '#1F2327';
export var ButtonTertiaryToggleGroupForegroundOffDisabled = '#CCD1D5';
export var ButtonTertiaryToggleGroupBackgroundOn = '#2D3C48';
export var ButtonTertiaryToggleGroupBackgroundOnHovered = '#2D3C48';
export var ButtonTertiaryToggleGroupBackgroundOnPressed = '#26333D';
export var ButtonTertiaryToggleGroupBackgroundOnDisabled = '#CCD1D5';
export var ButtonTertiaryToggleGroupBorderOn = '#2D3C48';
export var ButtonTertiaryToggleGroupBorderOnHovered = '#2D3C48';
export var ButtonTertiaryToggleGroupBorderOnPressed = '#26333D';
export var ButtonTertiaryToggleGroupBorderOnDisabled = '#CCD1D5';
export var ButtonTertiaryToggleGroupForegroundOn = '#ffffff';
export var ButtonTertiaryToggleGroupForegroundOnHovered = '#CCD1D5';
export var ButtonTertiaryToggleGroupForegroundOnPressed = '#ffffff';
export var ButtonTertiaryToggleGroupForegroundOnDisabled = '#6E767E';
export var FieldsBackgroundActive = '#FAFAFA';
export var FieldsBackgroundDisabled = '#FAFAFA';
export var FieldsBackgroundError = '#FFCCCC';
export var FieldsBackgroundInactive = '#FAFAFA';
export var FieldsBorderActive = '#2D3C48';
export var FieldsBorderDisabled = '#FAFAFA';
export var FieldsBorderError = '#C22626';
export var FieldsBorderInactive = '#FAFAFA';
export var FieldsForegroundActive = '#2D3C48';
export var FieldsForegroundDisabled = '#CCD1D5';
export var FieldsForegroundError = '#2D3C48';
export var FieldsForegroundInactive = '#2D3C48';
export var FieldsForegroundPlaceholder = '#4B5862';
export var FieldsIconDropdown = '#2D3C48';
export var FieldsIconSearch = '#2D3C48';
export var FieldsInputBackgroundDisabled = '#FAFAFA';
export var FieldsInputBorder = '#CCD1D5';
export var FieldsInputBorderError = '#AD2222';
export var GlobalPrimary = '#F86932';
export var GlobalSecondary = '#24B324';
export var ListCellContainerBackgroundHovered = '#FAFAFA';
export var ListCellContainerBackgroundPressed = '#EFF1F3';
export var ListCellIconToggledOn = '#F86932';
export var ListCellIconToggledOff = '#6E767E';
export var LoadingDefault = '#F86932';
export var OverlayBackgroundDefault = '#2D3C48';
export var OverlayLoadingDefault = '#F86932';
export var PageBackgroundSecondary = '#FAFAFA';
export var PageBackgroundTertiary = '#EFF1F3';
export var PaginationNumberedSelectedBackground = '#2D3C48';
export var PaginationNumberedSelectedBackgroundDisabled = '#CCD1D5';
export var PaginationNumberedSelectedBackgroundHovered = '#2D3C48';
export var PaginationNumberedSelectedBackgroundPressed = '#26333D';
export var PaginationNumberedSelectedBorder = '#2D3C48';
export var PaginationNumberedSelectedBorderDisabled = '#CCD1D5';
export var PaginationNumberedSelectedBorderHovered = '#2D3C48';
export var PaginationNumberedSelectedBorderPressed = '#26333D';
export var PaginationNumberedSelectedForeground = '#ffffff';
export var PaginationNumberedSelectedForegroundDisabled = '#6E767E';
export var PaginationNumberedSelectedForegroundHovered = '#ffffff';
export var PaginationNumberedSelectedForegroundPressed = '#ffffff';
export var PaginationNumberedUnselectedBackground = '#EFF1F3';
export var PaginationNumberedUnselectedBackgroundDisabled = '#FAFAFA';
export var PaginationNumberedUnselectedBackgroundHovered = '#EFF1F3';
export var PaginationNumberedUnselectedBackgroundPressed = '#CCD1D5';
export var PaginationNumberedUnselectedBorder = '#EFF1F3';
export var PaginationNumberedUnselectedBorderDisabled = '#FAFAFA';
export var PaginationNumberedUnselectedBorderHovered = '#EFF1F3';
export var PaginationNumberedUnselectedBorderPressed = '#CCD1D5';
export var PaginationNumberedUnselectedForeground = '#2D3C48';
export var PaginationNumberedUnselectedForegroundDisabled = '#CCD1D5';
export var PaginationNumberedUnselectedForegroundHovered = '#2D3C48';
export var PaginationNumberedUnselectedForegroundPressed = '#2D3C48';
export var PaginationSelectedDark = '#6E767E';
export var PaginationSelectedPrimary = '#F86932';
export var PaginationSelectedLight = '#ffffff';
export var PaginationUnselectedDark = '#CCD1D5';
export var PaginationUnselectedPrimary = '#CCD1D5';
export var PaginationUnselectedLight = '#EFF1F3';
export var SliderKnobBackground = '#2D3C48';
export var SliderKnobBackgroundHovered = '#26333D';
export var SliderKnobBackgroundPressed = '#26333D';
export var SliderKnobBackgroundDisabled = '#CCD1D5';
export var SliderTrackBackgroundOff = '#EFF1F3';
export var SliderTrackBackgroundOffDisabled = '#FAFAFA';
export var SliderTrackBackgroundOn = '#2D3C48';
export var SliderTrackBackgroundOnDisabled = '#CCD1D5';
export var SwitchBackgroundOn = '#2D3C48';
export var SwitchBackgroundOnDisabled = '#CCD1D5';
export var SwitchBackgroundOff = '#ffffff';
export var SwitchBackgroundOffDisabled = '#FAFAFA';
export var SwitchBorderOn = '#2D3C48';
export var SwitchBorderOnDisabled = '#CCD1D5';
export var SwitchBorderOff = '#2D3C48';
export var SwitchBorderOffDisabled = '#FAFAFA';
export var SwitchForegroundOn = '#ffffff';
export var SwitchForegroundOnDisabled = '#6E767E';
export var SwitchForegroundOff = '#ffffff';
export var SwitchForegroundOffDisabled = '#ffffff';
export var TagDefaultBackground = '#EFF1F3';
export var TagDefaultForeground = '#2D3C48';
export var TagDefaultIcon = '#2D3C48';
export var TagHighlightBackground = '#DEF1FA';
export var TagHighlightForeground = '#00678E';
export var TagHighlightIcon = '#00678E';
export var TagInformationalBackground = '#4B5862';
export var TagInformationalForeground = '#ffffff';
export var TagInformationalIcon = '#ffffff';
export var TagNegativeBackground = '#FFCCCC';
export var TagNegativeForeground = '#821A1A';
export var TagNegativeIcon = '#821A1A';
export var TagPositiveBackground = '#DFEFD9';
export var TagPositiveForeground = '#166B16';
export var TagPositiveIcon = '#166B16';
export var TagWarningBackground = '#FFF0C2';
export var TagWarningForeground = '#665214';
export var TagWarningIcon = '#665214';
export var TagInformationalDefaultBackground = '#EFF1F3';
export var TagInformationalDefaultForeground = '#2D3C48';
export var TagInformationalDefaultIcon = '#2D3C48';
export var TagInformationalEmphasisBackground = '#4B5862';
export var TagInformationalEmphasisForeground = '#ffffff';
export var TagInformationalEmphasisIcon = '#ffffff';
export var TagNegativeDefaultBackground = '#FFCCCC';
export var TagNegativeDefaultForeground = '#821A1A';
export var TagNegativeDefaultIcon = '#821A1A';
export var TagNegativeEmphasisBackground = '#D92B2B';
export var TagNegativeEmphasisForeground = '#ffffff';
export var TagNegativeEmphasisIcon = '#ffffff';
export var TagPositiveDefaultBackground = '#DFEFD9';
export var TagPositiveDefaultForeground = '#166B16';
export var TagPositiveDefaultIcon = '#166B16';
export var TagPositiveEmphasisBackground = '#24B324';
export var TagPositiveEmphasisForeground = '#ffffff';
export var TagPositiveEmphasisIcon = '#ffffff';
export var TagWarningDefaultBackground = '#FFF0C2';
export var TagWarningDefaultForeground = '#665214';
export var TagWarningDefaultIcon = '#665214';
export var TagWarningEmphasisBackground = '#FFCC33';
export var TagWarningEmphasisForeground = '#2D3C48';
export var TagWarningEmphasisIcon = '#2D3C48';
export var TagHighlightDefaultBackground = '#DEF1FA';
export var TagHighlightDefaultForeground = '#00678E';
export var TagHighlightDefaultIcon = '#00678E';
export var TagHighlightEmphasisBackground = '#00ACED';
export var TagHighlightEmphasisForeground = '#ffffff';
export var TagHighlightEmphasisIcon = '#ffffff';
export var TextAccentedPrimary = '#F86932';
export var TextAccentedSecondary = '#00ACED';
export var TextAction = '#F86932';
export var TextCallout = '#F86932';
export var TextDisabled = '#CCD1D5';
export var TextError = '#D92B2B';
export var TextHighlight = '#00ACED';
export var TextPositive = '#20A120';
export var TextPrimary = '#2D3C48';
export var TextPrimaryOnDark = '#ffffff';
export var TextSecondary = '#4B5862';
export var TextSecondaryOnDark = '#EFF1F3';
export var TextSelected = '#F86932';
export var TextTertiary = '#6E767E';
export var TextTooltip = '#6E767E';
export var TextWarning = '#E5B82E';
export var TimelineTrackBackgroundOff = '#EFF1F3';
export var TimelineTrackBackgroundOn = '#2D3C48';
export var TimelineTrackForegroundOff = '#2D3C48';
export var TimelineTrackForegroundOn = '#ffffff';
export var TimelineTrackShimmer = '#4B5862';
export var ToastInformationalBackground = '#4B5862';
export var ToastInformationalForeground = '#EFF1F3';
export var ToastInformationalAction = '#ffffff';
export var ToastInformationalActionPressed = '#CCD1D5';
export var ToastInformationalActionHovered = '#EFF1F3';
export var ToastInformationalActionDisabled = '#6E767E';
export var ToggleBackgroundOn = '#2D3C48';
export var ToggleBackgroundOnDisabled = '#CCD1D5';
export var ToggleBackgroundOff = '#ffffff';
export var ToggleBackgroundOffDisabled = '#FAFAFA';
export var ToggleBorderOn = '#2D3C48';
export var ToggleBorderOnDisabled = '#CCD1D5';
export var ToggleBorderOff = '#2D3C48';
export var ToggleBorderOffDisabled = '#FAFAFA';
export var ToggleForegroundOn = '#ffffff';
export var ToggleForegroundOnDisabled = '#6E767E';
export var ToggleForegroundOff = '#ffffff';
export var ToggleForegroundOffDisabled = '#ffffff';
export var TooltipHighlightBackground = '#009AD4';
export var TooltipHighlightBackgroundHovered = '#0089BD';
export var TooltipHighlightBackgroundPressed = '#0089BD';
export var TooltipHighlightForeground = '#ffffff';
export var TooltipHighlightForegroundHovered = '#ffffff';
export var TooltipHighlightForegroundPressed = '#ffffff';
export var TooltipInformationalBackground = '#2D3C48';
export var TooltipInformationalBackgroundHovered = '#26333D';
export var TooltipInformationalBackgroundPressed = '#1F2327';
export var TooltipInformationalForeground = '#EFF1F3';
export var TooltipInformationalForegroundHovered = '#EFF1F3';
export var TooltipInformationalForegroundPressed = '#EFF1F3';
export var WarningForeground = '#2D3C48';
export var WarningBackground = '#FFF0C2';